import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { AppText, styled, Tooltip, UIConstants } from '@streem/ui-react';
import { useObservable } from '../../../../hooks/rxjs';
import { map } from 'rxjs/operators';
import { useRoomSession } from '../../../../context/room_session';
import { RemoteUserName } from './remote_user_name';
import { RemoteAudioStatus } from './remote_audio_status';
export const ToolbarCallDetails = ({ isTrayOpen, roundLeftEdgeYn, roundRightEdgeYn, }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const roomSession = useRoomSession();
    const [remoteUser] = useObservable(roomSession.user.remoteUser);
    const [remoteAudioEnabled] = useObservable(roomSession.media.remoteAudio.muted.pipe(map(muted => !muted)));
    return (_jsx(CallDetailsContainer, { roundLeftEdgeYn: roundLeftEdgeYn, roundRightEdgeYn: roundRightEdgeYn, children: _jsxs(_Fragment, { children: [_jsx(Tooltip, { message: _jsx(AppText, { color: "dark", size: "small", children: `${remoteUser?.name ?? 'Client'} is ${remoteAudioEnabled ? 'Unmuted' : 'Muted'}` }), showTooltip: showTooltip, distance: 20, children: _jsx(CallDetailsIconWrapper, { width: '24px', onMouseEnter: () => setShowTooltip(true), onMouseOver: () => setShowTooltip(true), onMouseOut: () => setShowTooltip(false), children: _jsx(RemoteAudioStatus, { remoteAudioEnabled: remoteAudioEnabled }) }) }), _jsx(RemoteUserName, { isTrayOpen: isTrayOpen, remoteUser: remoteUser })] }) }));
};
const CallDetailsIconWrapper = styled.div((props) => ({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: props.width,
    height: `${UIConstants.BOTTOM_ROW_ELEMENT_HEIGHT_REM}rem`,
}));
const CallDetailsContainer = styled.div(({ roundLeftEdgeYn, roundRightEdgeYn, theme }) => ({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: `${UIConstants.BOTTOM_ROW_ELEMENT_HEIGHT_REM}rem`,
    paddingLeft: '1.125rem',
    paddingRight: '.75rem',
    gap: '.75rem',
    borderTopLeftRadius: roundLeftEdgeYn
        ? UIConstants.ROUNDED_BUTTON_BORDER_RADIUS
        : UIConstants.STANDARD_BUTTON_BORDER_RADIUS,
    borderBottomLeftRadius: roundLeftEdgeYn
        ? UIConstants.ROUNDED_BUTTON_BORDER_RADIUS
        : UIConstants.STANDARD_BUTTON_BORDER_RADIUS,
    borderTopRightRadius: roundRightEdgeYn
        ? UIConstants.ROUNDED_BUTTON_BORDER_RADIUS
        : UIConstants.STANDARD_BUTTON_BORDER_RADIUS,
    borderBottomRightRadius: roundRightEdgeYn
        ? UIConstants.ROUNDED_BUTTON_BORDER_RADIUS
        : UIConstants.STANDARD_BUTTON_BORDER_RADIUS,
    backgroundColor: theme.colors.grey10,
}));
//# sourceMappingURL=toolbar_call_details.js.map